import { createAsyncThunk } from '@reduxjs/toolkit';
import { getConnectwiseContacts } from 'services/connectwise';

interface IProps {
  psaId: number;
  companyId?: number;
}

export const ThunkGetConnectwiseContacts = createAsyncThunk(
  'connectwise/getConnectwiseContacts',
  ({ psaId, companyId }: IProps) =>
    getConnectwiseContacts(psaId, companyId)
      .then(res => res.data)
      .then(data => data.sort((a, b) => a.label.localeCompare(b.label))),
);

export default {};
